<template>
    <div class="api-chart" ref="apiChart"></div>
</template>

<script>
/* eslint-disable */
import { get } from '@/api/index'
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            chartData: {},
        }
    },
    props: ['apiId', 'chartUData'],
    mounted() {
        if (JSON.stringify(this.apiChartData) !== '{}') {
            this.initChart(this.apiChartData);
        }
    },
    watch: {
        apiChartData: function () {
            if (JSON.stringify(this.apiChartData) !== '{}') {
                this.initChart(this.apiChartData);
            }
        },
        chartUData: function (e) {
            this.initChart(e);
        }
    },
    computed: {
        ...mapState([
            'token',
            'apiChartData'
        ])
    },
    methods: {
        // ...mapActions([
        //     'getChartData'
        // ]),

        // 图表初始化
        initChart(datas) {
            
            if (JSON.stringify(datas) !== '{}') {
                var node = this.$refs.apiChart;
                var myChart = this.$echarts.init(node);
                var equityData = datas[this.apiId].equity_usdt;
                var equity_rate_data = datas[this.apiId].rate_usdt;
                var x_data = datas[this.apiId].dateTime;
                var option = {
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        formatter: function (param) {
                            var htmlStr = param[0].axisValue + '<br>';
                            var currency_value = equityData[param[0].dataIndex];
                            htmlStr += param[0].marker + 'USDT' + ': ' + currency_value.toFixed(2);
                            return htmlStr;
                        },
                        position: [0, 30]
                    },
                    calculable : true,
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '-30%',
                        top: '2%',
                        containLabel: true 
                    },
                    dataZoom: [{
                        type: 'inside',
                        start: 30,
                        end: 100
                    }],
                    xAxis: [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data : x_data,
                            show: false,
                            axisTick: {
                                show: false,
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type : 'value',
                            show: false,
                            axisLabel: {
                                show: false,
                            },
                            axisTick: {
                                show: false,
                            },
                            splitLine: {
                                show: false,
                            }
                        },
                    ],
                    series: [
                        {
                            name: name,
                            type:'line',
                            symbol: 'none',
                            smooth: true,
                            showSymbol: false,
                            data: equity_rate_data,
                            lineStyle: {
                                color: '#18A689',
                                width: 1
                            }
                        },
                    ]
                };
    
                myChart.setOption(option);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .api-chart{
        height: 30px;
        width: 80px;
        margin: 0 auto;
    }
</style>
